import { render, staticRenderFns } from "./monitor_sel.vue?vue&type=template&id=9bbd2ad6&scoped=true"
import script from "./monitor_sel.vue?vue&type=script&lang=js"
export * from "./monitor_sel.vue?vue&type=script&lang=js"
import style0 from "./monitor_sel.vue?vue&type=style&index=0&id=9bbd2ad6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bbd2ad6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9bbd2ad6')) {
      api.createRecord('9bbd2ad6', component.options)
    } else {
      api.reload('9bbd2ad6', component.options)
    }
    module.hot.accept("./monitor_sel.vue?vue&type=template&id=9bbd2ad6&scoped=true", function () {
      api.rerender('9bbd2ad6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/iot/monitor/monitor_sel.vue"
export default component.exports